module.exports = __webpack_public_path__ + "static/media/theseventales.e13fcaa1.jpg";